(function () {
  function amount(value) {
    var decimal = value.match(/[.,](\d{2})$/);
    var whole = decimal ? value.slice(0, -3) : value;
    whole = whole.replace(/[.,]/g, '');
    return whole + (decimal && decimal[1] !== '00' ? ',' + decimal[1] : '');
  }
  function format(value) {
    return value
      .replace(/\s*—\s*/g, ', ').replace(/–/g, '-')
      .replace(/€[\s\u00a0]*([0-9]+(?:[.,][0-9]+)*)(\+?)/g, function (_, n, plus) { return amount(n) + '\u00a0€' + plus; })
      .replace(/([0-9]+(?:[.,][0-9]+)*)[\s\u00a0]*€/g, function (_, n) { return amount(n) + '\u00a0€'; });
  }
  function update(root) {
    if (root.nodeType === 3) {
      if (!root.parentElement || root.parentElement.closest('script,style,textarea,input,svg,[contenteditable]')) return;
      var next = format(root.nodeValue);
      if (root.parentElement.closest('.cc-pdp-delivery-compact')) next = next.replace(/2-3/g, '2–3');
      if (next !== root.nodeValue) root.nodeValue = next;
      return;
    }
    if (root.nodeType !== 1 || root.closest('script,style,textarea,input,svg,[contenteditable]')) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) update(walker.currentNode);
  }
  function start() {
    update(document.body);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.type === 'characterData') update(change.target);
        else change.addedNodes.forEach(update);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
